import React from 'react';
import { ArrowRightIcon, ShieldCheckIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
import { TestimonialCard } from './TestimonialCard';
export function PricingSection() {
  const {
    isExpired
  } = useCountdown();
  return <div className="grain-section w-full px-6 py-32 md:py-40 bg-white" data-id="element-277">
      <div className="max-w-5xl mx-auto space-y-20" data-id="element-278">
        {/* Pricing Card */}
        <div className="relative" data-id="element-279">
          <div className="relative bg-white border border-teal-200 p-8 md:p-20 text-center space-y-10 shadow-2xl shadow-teal-100/50 rounded-[3rem]" data-id="element-280">
            {/* Top Accent */}
            <div className="absolute top-0 left-0 right-0 h-2 bg-gradient-to-r from-teal-400 to-teal-600 rounded-t-[3rem]" data-id="element-281"></div>

            <div className="space-y-4" data-id="element-282">
              <p className="text-sm text-teal-700 font-bold uppercase tracking-widest bg-teal-50 inline-block px-4 py-1.5 rounded-full border border-teal-100" data-id="element-283">
                {isExpired ? 'Standard Rate' : 'For a limited time'}
              </p>
              <h3 className="text-4xl md:text-6xl font-bold text-ink pt-4 tracking-tight" data-id="element-284">
                Meeting With the Master: <br data-id="element-285" />
                <span className="text-teal-600" data-id="element-286">ADVANCED</span>
              </h3>
              <p className="text-xl text-ink-light font-light" data-id="element-287">
                Delivered in a single, powerful 2–3 hour session
              </p>
            </div>

            <div className="py-8" data-id="element-288">
              {isExpired ? <div className="flex items-center justify-center" data-id="element-289">
                  <span className="text-6xl sm:text-8xl md:text-[10rem] font-black text-teal-600 tracking-tighter leading-none" data-id="element-290">
                    $5,000
                  </span>
                </div> : <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4" data-id="element-291">
                  <span className="text-3xl sm:text-4xl text-gray-400 line-through font-bold" data-id="element-292">
                    $5,000
                  </span>
                  <span className="text-6xl sm:text-8xl md:text-[10rem] font-black text-teal-600 tracking-tighter leading-none" data-id="element-293">
                    $1,500
                  </span>
                </div>}
              <p className="text-teal-600 font-bold mt-4" data-id="element-294">
                Only Limited Slots Available
              </p>
            </div>

            <p className="text-xl text-ink-light max-w-3xl mx-auto font-light leading-relaxed" data-id="element-295">
              If you're ready to stop messing around with guesswork, and you're
              ready to find out exactly what to do next for YOUR unique
              situation and your unique biology, this is your opportunity.
            </p>

            <div className="pt-8 space-y-8" data-id="element-296">
              <a href="https://go.peptidescienceinstitute.com/meeting-with-the-master-advanced" className="inline-flex items-center justify-center gap-3 w-full sm:w-auto px-8 sm:px-12 py-6 bg-gradient-to-r from-[#1d1d1f] to-[#2d2d2f] hover:from-black hover:to-[#1a1a1c] text-white text-xl sm:text-2xl font-bold rounded-full transition-all shadow-lg hover:shadow-xl hover:-translate-y-1" data-id="element-297">
                Secure Your Slot Now
                <ArrowRightIcon className="w-6 h-6" data-id="element-298" />
              </a>

              <div className="flex flex-col md:flex-row justify-center gap-6 text-sm text-ink-light pt-4" data-id="element-299">
                <div className="flex items-center gap-2" data-id="element-300">
                  <ShieldCheckIcon className="w-5 h-5 text-teal-500" data-id="element-301" />
                  <span data-id="element-302">Pre-Session Fit</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-303">
                  <ShieldCheckIcon className="w-5 h-5 text-teal-500" data-id="element-304" />
                  <span data-id="element-305">End-of-Session Clarity</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Testimonials at the bottom */}
        <div className="space-y-8 pt-8" data-id="element-306">
          <TestimonialCard text="I am a physician with an integrative medicine practice and your work has been very valuable in treating my patients. When I lecture to physicians I always mention 'peptide mastery' as a great source of material and extensive references... It has been very helpful in my care of patients and I appreciate the extensive references." name="Ronald R. MD, Peptide Mastery Owner" data-id="element-307" />
          <TestimonialCard text="I'm going through the peptide mastery and all the other peptide courses and resources I've purchased from you guys (I am LOVING it all!!)... I'm a functional medicine practitioner and I can't wait to incorporate some of these protocols with my patients!!!" name="Michelle M.N., Doctor of Chiropractic & Certified Functional Medicine Practitioner" data-id="element-308" />
        </div>
      </div>
    </div>;
}